// src/config/counties.js
// Multi-county configuration. Each subdomain (e.g. larimer.votergo.app) maps to
// one entry here. votergo.app (no matching subdomain) shows the county selector.

export const COUNTIES = {
  larimer: {
    id: 'larimer',
    subdomain: 'larimer',
    name: 'Larimer County',
    orgName: 'Larimer County Republican Party',
    orgAddress: '4020 S. College Ave., Fort Collins, CO 80525',
    orgWebsite: 'https://www.larimergop.org',
    orgEmail: 'info@larimergop.org',
    orgLogo: '/larimer_logo.png',
    eventSubmitFormUrl: 'https://airtable.com/appHqhh20NqkEjJXk/pag7S8qLtiyS0O721/form',
    eventSubmitEmbedUrl: 'https://airtable.com/embed/appHqhh20NqkEjJXk/pag7S8qLtiyS0O721/form',
    airtableBaseId: process.env.REACT_APP_AIRTABLE_BASE_ID_LARIMER || process.env.REACT_APP_AIRTABLE_BASE_ID,
    airtableToken: process.env.REACT_APP_AIRTABLE_TOKEN_LARIMER || process.env.REACT_APP_AIRTABLE_TOKEN,
    adminPassword: process.env.REACT_APP_ADMIN_PASSWORD,
    districtMapType: 'gis',
    whereToVoteType: 'citymaps',
    whereToVoteUrl: 'https://www.larimer.gov/clerk/elections/where-to-vote',
    autocompleteBounds: { north: 41.003444, south: 40.259874, east: -104.902038, west: -105.715732 },
    // City-level filter categories for the Ballot Initiatives page
    ballotCityLevels: ['Fort Collins', 'Loveland', 'Berthoud'],
    // Airtable field name holding the county party's position on a ballot initiative
    ballotPositionField: 'LCRP Position',
  },
  weld: {
    id: 'weld',
    subdomain: 'weld',
    name: 'Weld County',
    orgName: 'Weld County Republican Party',
    orgAddress: '',
    orgWebsite: '',
    orgEmail: '',
    orgLogo: '/weld_logo.png',
    eventSubmitFormUrl: 'https://airtable.com/app4ygSQQgKH9T3Jk/pag4wgyBkIEcTVJ2Q/form',
    eventSubmitEmbedUrl: 'https://airtable.com/embed/app4ygSQQgKH9T3Jk/pag4wgyBkIEcTVJ2Q/form',
    airtableBaseId: process.env.REACT_APP_AIRTABLE_BASE_ID_WELD,
    airtableToken: process.env.REACT_APP_AIRTABLE_TOKEN_WELD,
    adminPassword: process.env.REACT_APP_ADMIN_PASSWORD_WELD,
    districtMapType: 'iframe',
    districtMapUrl: 'https://maps.weld.gov/gisapps/web/?app=b17c254598f34f07b7b92f3a5a3152aa&workflow=ca805e0c-96ca-4f0f-aedc-3a4d64850e7a&workflowParams={%22theme%22:%22election%22}',
    whereToVoteType: 'iframe',
    whereToVoteUrl: 'https://apps.weld.gov/clerkrecorder/elections/maps/',
    autocompleteBounds: { north: 40.9276, south: 39.9042, east: -103.9973, west: -105.0324 },
    // City-level filter categories for the Ballot Initiatives page
    ballotCityLevels: ['Greeley', 'Windsor', 'Evans', 'Fort Lupton', 'Johnstown'],
    // Airtable field name holding the county party's position on a ballot initiative
    ballotPositionField: 'WCRP Position',
  },
};

export const COUNTY_STORAGE_KEY = 'votergo_county';

// Persist the user's chosen county so a return visit to the root domain
// (votergo.app) doesn't show the selector again if subdomain routing
// isn't available (e.g. local dev, or before DNS/redirects are set up).
export const saveCountySelection = (id) => {
  try {
    if (typeof window !== 'undefined' && COUNTIES[id]) {
      window.localStorage.setItem(COUNTY_STORAGE_KEY, id);
    }
  } catch {
    // localStorage unavailable (e.g. private browsing) — ignore
  }
};

// Detects which county to load from the current hostname's subdomain first
// (production always wins on this), then a `?county=` query param — so
// counties are testable on localhost, where there are no real subdomains to
// redirect between — then finally a previously saved localStorage selection.
// `?county=select` forces the selector open, overriding any saved selection.
export const detectCountyId = (
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
  search = typeof window !== 'undefined' ? window.location.search : ''
) => {
  const sub = hostname.toLowerCase().split('.')[0];
  const bySubdomain = Object.values(COUNTIES).find(c => c.subdomain === sub);
  if (bySubdomain) return bySubdomain.id;

  const queryCounty = new URLSearchParams(search).get('county');
  if (queryCounty === 'select') return null;
  if (queryCounty && COUNTIES[queryCounty]) return queryCounty;

  try {
    const saved = typeof window !== 'undefined' ? window.localStorage.getItem(COUNTY_STORAGE_KEY) : null;
    if (saved && COUNTIES[saved]) return saved;
  } catch {
    // localStorage unavailable — ignore
  }

  return null;
};

export const getCounty = (id) => COUNTIES[id] || null;

export const getCurrentCounty = () => getCounty(detectCountyId());
